import { BlockedCreator } from "@next-platform/client-common-core";
import { Divider } from "@nextui-org/divider";
import { Avatar, AvatarVariantProps } from "@nextui-org/react";
import React, { useCallback } from "react";

import { SpicyButton } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";

const AVATAR_COLORS = ["primary", "error", "secondary", "warning", "success"] as const;
const AVATAR_NAME_CLASS_NAMES = { name: "pb-1" };

type BlockedCreatorListItemProps = {
  creator: BlockedCreator;
  creatorIndex: number;
  onUnblockPress: ({ creatorId, username }: { creatorId: string; username: string }) => void;
  "data-testid"?: string;
};

const BlockedCreatorListItem = ({
  creator,
  creatorIndex,
  onUnblockPress,
  "data-testid": testId = "BlockedCreatorListItem",
}: BlockedCreatorListItemProps) => {
  const handleUnblockPress = useCallback(() => {
    onUnblockPress({ creatorId: creator.id, username: creator.username });
  }, [creator.id, creator.username, onUnblockPress]);

  return (
    <div data-testid={testId}>
      {creatorIndex !== 0 ? <Divider /> : null}
      <div className="flex justify-between items-center my-4">
        <div className="flex gap-2 items-center">
          <Avatar
            color={AVATAR_COLORS[creatorIndex % AVATAR_COLORS.length] as AvatarVariantProps["color"]}
            className="text-large text-white"
            classNames={AVATAR_NAME_CLASS_NAMES}
            name={creator.username?.[0]?.toUpperCase()}
          />
          <LocalizedLink className="text-link no-underline" to={`/creator/${creator.username}`} aria-label="creator-profile">
            @{creator.username}
          </LocalizedLink>
        </div>
        <SpicyButton color="primary_strong" onClick={handleUnblockPress} size="sm" data-testid="BlockedCreatorListItem-UnblockButton">
          <Trans i18nKey="creator:cta.unblock" />
        </SpicyButton>
      </div>
    </div>
  );
};

export default React.memo(BlockedCreatorListItem);
